<template>
  <CustomBlipLineChart
    :request-status="requestStatus"
    :series="series"
    :title="title"
    :item-id="itemId"
    :card-options="cardOptions"
    v-bind="$attrs"
    @reload="getData"
  />
</template>

<script>
import CustomBlipLineChart from '@/components/cards/models/CustomBlipLineChart';
import { mapActions } from 'vuex';
import EventBus from '@/utils/event-bus';
import colors from '@/utils/colors';

export default {
  name: 'BlipMessageVolumeInPeriod',
  components: {
    CustomBlipLineChart,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
    servicePath: {
      type: String,
      required: true,
    },
    interval: {
      type: String,
      default: 'D',
    },
  },
  data() {
    return {
      requestStatus: 'loading',
      rawSeries: [],
      categories: [],
      dataLabel: [
        this.$t('components.BlipMessageVolumeInPeriod.label.series.receivedMessages'),
        this.$t('components.BlipMessageVolumeInPeriod.label.series.sentMessages'),
      ],
    };
  },
  computed: {
    cardOptions() {
      return {
        chart: {
          type: 'spline',
        },
        legend: {
          enabled: true,
        },
        yAxis: {
          gridLineWidth: 0.5,
          tickLength: 0,
        },
      };
    },
    series() {
      if (!this.rawSeries && !this.rawSeries.length) {
        return [];
      }
      return this.rawSeries;
    },
  },
  created() {
    this.getData();
  },
  methods: {
    ...mapActions('cards', [
      'getBlipService',
    ]),
    getData(options) {
      if (!options?.silentRefresh) {
        this.requestStatus = 'loading';
      }

      this.rawSeries = [];
      this.categories = [];

      this.getBlipService({
        servicePath: this.servicePath,
        interval: this.interval,
        itemId: this.itemId,
      })
        .then(([responseReceived, responseSent]) => {
          const rawCategories = responseReceived.resource?.items?.map(({ intervalStart }) => intervalStart);

          this.categories = this.formattedCategories(rawCategories);
          this.rawSeries.push(this.formattedSeries(responseReceived, true));
          this.rawSeries.push(this.formattedSeries(responseSent));
          this.requestStatus = 'success';

          if (options?.silentRefresh) {
            EventBus.$emit('updated', { itemId: this.itemId });
          }
        })
        .catch(error => {
          console.error(error);
          this.requestStatus = 'error';
        });
    },
    formattedCategories(rawCategories) {
      const completeCategories = rawCategories.map(this.ISODateToTimestamp);

      return completeCategories;
    },
    formattedSeries(rawSeries, firstResponse = false) {
      const [firstLabel, secondLabel] = this.dataLabel;
      const name = firstResponse
        ? firstLabel
        : secondLabel;

      const color = firstResponse
        ? colors.componentsColor.seriesYellow56
        : colors.componentsColor.seriesBrandPure;

      const data = rawSeries.resource?.items?.map(this.normalizeSeries);

      return {
        name,
        data,
        color,
        marker: {
          symbol: 'circle',
        },
      };
    },
    normalizeSeries({ count, intervalStart }) {
      return [this.ISODateToTimestamp(intervalStart), count];
    },
    ISODateToTimestamp(ISODate) {
      return new Date(ISODate).getTime();
    },
  },
};
</script>
